import React, { createContext, useContext, useState, ReactNode } from 'react';
import { StationSelectedContextValue, StationTabType } from '../types';

const StationSelectedTabContext = createContext<StationSelectedContextValue | undefined>(undefined);

interface StationSelectedTabProviderProps {
  children: ReactNode;
  defaultTab?: StationTabType;
}

export const StationSelectedTabProvider: React.FC<StationSelectedTabProviderProps> = ({
  children,
  defaultTab = StationTabType.ALL_STATIONS,
}) => {
  const [activeTab, setActiveTab] = useState<StationTabType>(defaultTab);

  const value: StationSelectedContextValue = {
    activeTab,
    setActiveTab,
  };

  return <StationSelectedTabContext.Provider value={value}>{children}</StationSelectedTabContext.Provider>;
};

export const useStationSelectedTabContext = (): StationSelectedContextValue => {
  const context = useContext(StationSelectedTabContext);
  if (context === undefined) {
    throw new Error('useStationSelected must be used within a StationSelectedProvider');
  }
  return context;
};
